import { render, staticRenderFns } from "./NewAjuste.vue?vue&type=template&id=4cf50241"
import script from "./NewAjuste.vue?vue&type=script&lang=js"
export * from "./NewAjuste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports